export const getStyledImage = () => {
    return {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: '50% 10%',
    };
};
